module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length == 0) ? _c('span', [_vm._v("Please Wait, the data of " + _vm._s(_vm.curArea) + " is loading.")]) : _c('editable-table', {
    attrs: {
      "title": (_vm.curArea + " Alert Ignore List").toUpperCase(),
      "column-names": _vm.columnNames,
      "rows": _vm.rows,
      "save": _vm.onSave()
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab98bfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/AlertIgnore/AlertIgnore.vue
// module id = 1088
// module chunks = 1